import type { ReactElement } from 'react';

import { ModelChatSettingsCard } from '../dashboard/ModelChatSettingsCard.js';
import { ModelClosetCard } from '../dashboard/ModelClosetCard.js';
import { ModelGamesCard } from '../dashboard/ModelGamesCard.js';
import { ModelJukeboxCard } from '../dashboard/ModelJukeboxCard.js';
import { ModelTipMenuCard } from '../dashboard/ModelTipMenuCard.js';
import { ModelToysCard } from '../dashboard/ModelToysCard.js';
import { SettingsStack } from './SettingsStack.js';

export function SettingsRoomPage(): ReactElement {
  return (
    <SettingsStack titleKey="common.studio.settings.roomTitle" hintKey="common.studio.settings.roomHint">
      <ModelChatSettingsCard />
      <ModelTipMenuCard />
      <ModelToysCard />
      <ModelClosetCard />
      <ModelJukeboxCard />
      <ModelGamesCard />
    </SettingsStack>
  );
}
